export default __webpack_public_path__ + "static/media/task_care_team_icon.7e50397d.svg";